const initialState = {
  jobs: [],
};

export default function jobsReducer(state = initialState, action) {
  switch (action.type) {
    case "JOBS_SUCCESS":
      return { ...state, jobs: action.payload };
    case "JOB_DELETED":
      return {
        ...state,
        jobs: state.jobs.filter((job) => job._id !== action.payload),
      };
    case "UPDATE_JOB_SUCCESS":
      return {
        ...state,
        jobs: state.jobs.map((job) =>
          job._id === action.payload._id ? action.payload : job
        ),
      };
    default:
      return state;
  }
}
